
import { DashboardItem, DashboardItemType, DashboardItemsVisibleWithoutPermissions } from "@/utils/dashboard/dashboard-item";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";
import AppCustomSettings from "./CustomSettings.vue";
import { UserConfigService } from "@/services";
import { Permissions } from "@/models/user-configs/permissions";

export default Vue.extend({
	data(){
		return {
			page: "default",
			item: null as DashboardItem | null
		};
	},
	props: {
		items: {
			type: Array as ()=>DashboardItem[],
			required: true
		}
	},
	computed: {
		title():TranslateResult{
			return this.$ct("dashboard-add-custom-item");
		},
		hasPermissions():boolean {
			return UserConfigService.hasCurrentUserPermission((p:Permissions)=>p.CanSeeDashboard);
		},
		types():ISelectItem<DashboardItemType>[]{
			let keys = Object.keys(DashboardItemType);
			let result:ISelectItem<DashboardItemType>[] = keys.map((k,i)=>{
				return {
					value: Object.values(DashboardItemType)[i],
					text: this.$ct(`item-type.${k}`)
				} as ISelectItem<DashboardItemType>;
			});
			if (!this.hasPermissions){
				result = result.filter((r:ISelectItem<DashboardItemType>)=>{
					return DashboardItemsVisibleWithoutPermissions.indexOf(r.value) != -1;
				});
			}
			return result;
		},
	},
	methods: {
		close(){
			this.$emit("close");
		},
		onItem(){
			if (!this.item)return;
			this.items.push(this.item);
		},
		selectItemType(t:DashboardItemType){
			this.item = DashboardItem.createNewByType(t);
			if (t == DashboardItemType.IFRAME || t == DashboardItemType.IMAGE || t == DashboardItemType.BANK_SALDO){
				this.page = "custom";
				return;
			}
			this.items.push(this.item);
			this.close();
		}
	},
	components: {
		AppCustomSettings
	},
	i18nEx: {
		componentPrefix: "components.dashboard"
	}
});
